import { createContext, useContext, useState, useCallback } from "react";
import { api } from "@/lib/apiClient";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(
    () => !!localStorage.getItem("rcv_admin_pwd")
  );

  const login = useCallback(async (password) => {
    await api.post("/auth/verify", { password });
    localStorage.setItem("rcv_admin_pwd", password);
    setIsAdmin(true);
    return true;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("rcv_admin_pwd");
    setIsAdmin(false);
  }, []);

  return (
    <AdminContext.Provider value={{ isAdmin, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  return useContext(AdminContext);
}
